export default __webpack_public_path__ + "static/nosotros-c204f5c6ebfeb5e329b4188c782a9226.jpg";